import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_t_link = _resolveComponent("t-link");
  const _component_t_footer = _resolveComponent("t-footer");
  return _openBlock(), _createBlock(_component_t_footer, {
    class: "library-choose-footer"
  }, {
    default: _withCtx(() => [_createVNode(_component_t_link, {
      style: 'color: #8BA1F7;',
      hover: "color",
      onClick: _ctx.goContactus
    }, {
      default: _withCtx(() => [_createTextVNode("联系我们 ")]),
      _: 1
    }, 8, ["onClick"]), _createTextVNode(" Copyright © 1998 - 2023 Tencent. All Rights Reserved. 腾讯公司 版权所有 ")]),
    _: 1
  });
}